import React from 'react'
import {ActionSheet, Dialog, Toptips, Toast} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { connect } from 'react-redux'
import {WKInfiniteScroll, WKCommentDialog} from '../../components/wk'
import { getHumanTime, isLZWKAPP } from '../../utils'
import { updateSuccess, goBack } from '../../utils/connectApp'
import niceCommentImg from '../../images/recorded/nice-comment.png'
import topCommentImg from '../../images/recorded/top-comment.png'
import noItemImg from '../../images/ban-no-item.png'
import privateCommentImg from '../../images/recorded/private-comment.png'


class LectureCommmentManagePage extends React.Component{
    constructor (props) {
        super(props)
        this.baseAsMenu = [{
            label: '私密回复',
            onClick: () => this.onClickPrivateAs()
        }, {
            label: '删除评论',
            onClick: () => this.setState({ isShowAs: false, isShowDelCommentDialog: true })
        }, {
            label: '拉黑',
            onClick: () => this.onClickBlockAs()
        }]
        this.state = {
            asMenu: this.cancleAsMenu,
            isShowAs: false,
            selectedCommentId: '',
            selectedCommentIndex: '',
            comments: null,
            commentsOffset: 0,
            commentsHasMore: true,
            isShowSuccessToast: false,
            successToastText: '',
            commentsCount: 0,
            isShowSetNiceDialog: false,
            isShowSetTopDialog: false,
            isShowDelCommentDialog: false,
            isShowSetBlackDialog: false,
            selectedUid: '',
            isShowPrivateReplyDialog: false,
            privateText: '',
            isPending: false,
            isScrollPending: false,
            selectedFilter: 'all',
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            isShowFilterAs: false,
        }
    }
    componentDidMount () {
        document.title = '评论管理'
        this.fetchComments()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onClickBlockAs () {
        if (this.props.account.id === this.state.selectedUid) {
            return this.showTip('不能拉黑自己')
        }
        this.setState({ isShowAs: false, isShowSetBlackDialog: true })
    }
    onClickPrivateAs () {
        if (this.props.account.id === this.state.selectedUid) {
            return this.showTip('不能私密回复自己')
        }
        this.setState({ isShowPrivateReplyDialog: true, isShowAs: false })
    }
    showSuccessToast (text) {
        this.setState({ isShowSuccessToast: true, successToastText: text })
        setTimeout(() => {
            this.setState({ isShowSuccessToast: false })
        }, 1000)
    }
    fetchComments () {
        this.setState({ isScrollPending: true })
        axios.get(`/api/lecture/${this.props.params.lecture_id}/discuss/list`, {
            params: {
                offset: this.state.commentsOffset,
                filtered: this.state.selectedFilter,
            }
        })
            .then(res => {
                if (res.data.code === 0) {
                    const data = res.data.data
                    this.setState({
                        comments: (this.state.comments || []).concat(data.discusses),
                        commentsCount: data.total_count,
                        isScrollPending: false,
                        commentsHasMore: data.has_more,
                        commentsOffset: data.next_offset,
                    })
                }
            })
    }
    onClickCommentItem (item, i) {
        let menu = this.baseAsMenu
        if (!item.is_top) {
            menu = [{
                label: '置顶精选',
                onClick: () => this.setState({ isShowSetTopDialog: true, isShowAs: false })
            }].concat(menu)
        } else {
            menu = [{
                label: '取消置顶',
                onClick: () => this.manageComment('cancel_top')
            }].concat(menu)
        }
        if (!item.is_filtered) {
            menu = [{
                label: '设为精选',
                onClick: () => this.setState({ isShowSetNiceDialog: true, isShowAs: false })
            }].concat(menu)
        } else {
            menu = [{
                label: '取消精选',
                onClick: () => this.manageComment('cancel_filtered')
            }].concat(menu)
        }
        this.setState({
            selectedCommentId: item.id,
            selectedCommentIndex: i,
            asMenu: menu,
            isShowAs: true,
            selectedUid: item.account.id,
        })
    }
    // top, cancel_top, filtered, cancel_filtered
    manageComment (action) {
        if (isLZWKAPP()) {
            updateSuccess({ type: 'lecture' })
        }
        const { selectedCommentIndex, comments } = this.state
        axios.post(`/api/lecture/${this.props.params.lecture_id}/discuss/${this.state.selectedCommentId}/manage`, qs.stringify({
            action,
        }))
            .then((res)=>{
                this.setState({ comments, isShowAs: false, isShowSetTopDialog: false, isShowSetNiceDialog: false })
                if(res.data.code === 1){
                    this.showTip(res.data.msg)
                    return
                }
                if (action === 'top') {
                    comments[selectedCommentIndex].is_top = true
                    comments[selectedCommentIndex].is_filtered = true
                }
                if (action === 'cancel_top') comments[selectedCommentIndex].is_top = false
                if (action === 'filtered') comments[selectedCommentIndex].is_filtered = true
                if (action === 'cancel_filtered') {
                    comments[selectedCommentIndex].is_filtered = false
                    comments[selectedCommentIndex].is_top = false
                }
                if (['cancel_top', 'cancel_filtered'].includes(action)) {
                    this.showSuccessToast('取消成功')
                } else {
                    this.showSuccessToast('')
                }
            })

    }
    handleDelComment (isHideToast = false) {
        if (isLZWKAPP()) {
            updateSuccess({ type: 'lecture' })
        }
        axios.post(`/api/classroom/${this.props.params.lecture_id}/discuss/${this.state.selectedCommentId}/delete`)
            .then(res => {
                if (res.data.code === 0) {
                    const comments = this.state.comments.filter((item, i) => i !== this.state.selectedCommentIndex)
                    this.setState({ comments, isShowDelCommentDialog: false, commentsCount: this.state.commentsCount - 1 })
                    if (!isHideToast) this.showSuccessToast('删除成功')
                } else {
                    this.showTip(res.data.msg)
                }
            })
    }
    handleSetBlack () {
        if (isLZWKAPP()) {
            updateSuccess({ type: 'lecture' })
        }
        axios.post(`/api/liveroom/${this.props.location.query.liveroom_id}/block_account`, qs.stringify({
            account_id: this.state.selectedUid,
        }))
            .then(res => {
                if (res.data.code === 0){
                    this.showSuccessToast('拉黑成功')
                    this.handleDelComment(true)
                    this.setState({ isShowSetBlackDialog: false })
                } else {
                    this.showTip(res.data.msg)
                }
            })
    }
    handleSendPrivateComment () {
        if (this.state.privateText.trim() === '') {
            return this.showTip('评论不能为空')
        }
        if (isLZWKAPP()) {
            updateSuccess({ type: 'lecture' })
        }
        this.setState({ isPending: true })
        axios.post(`/api/lecture/${this.props.params.lecture_id}/discuss/${this.state.selectedCommentId}/private_reply`, qs.stringify({
            msg_type: 'text',
            content: this.state.privateText,
            receiver_id: this.state.selectedUid,
        }))
            .then(res => {
                if (res.data.code === 0) {
                    this.showSuccessToast('发送成功')
                    this.state.comments[this.state.selectedCommentIndex].private_replies.push({
                        content: this.state.privateText,
                        id: Date.now(),
                        sender: {
                            nickname: this.props.account.nickname
                        }
                    })
                    this.setState({ 
                        privateText: '', 
                        isShowPrivateReplyDialog: false, 
                        isPending: false,
                        comments: this.state.comments
                    })
                } else {
                    this.setState({ 
                      isPending: false
                    })
                    this.showTip(res.data.msg)
                }
            })
    }
    renderFilterAs () {
        const { selectedFilter } = this.state
        const sheetList = [
            { type: 'all', name: '全部' },
            { type: 'filtered', name: '精选' },
            { type: 'top', name: '置顶' },
        ]
        return (
            <div>
                <div className="selectbar-title">
                    选择筛选类型
                </div>
                <div className="selectbar-container">
                    <div className="row">
                        {
                            sheetList.map((item, i) => {
                                return (
                                    <div 
                                        key={i} 
                                        className={`selectbar-item ${selectedFilter === item.type ? 'selectbar-item-active' : ''}`}
                                        onClick={e => this.handleSelectFilter(item.type)}
                                    >
                                        {item.name}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
    handleSelectFilter (type) {
        this.setState({ 
            selectedFilter: type, 
            isShowFilterAs: false, 
            commentsOffset: '', 
            comments: null, 
            commentsCount: 0, 
            commentsHasMore: true,
        }, () => {
            this.fetchComments(type)
        })
    }
    getLiveroomName (name) {
        if (name.length > 12) {
            return name.substring(0, 12) + '...'
        } else {
            return name
        }
    }
    onClickBack () {
        location.assign(`/lecture/${this.props.params.lecture_id}`)
    }
    render() {
        const { asMenu, isShowAs, comments, commentsHasMore, successToastText, commentsCount } = this.state
        return (
            <div className="lecture-comment-manage-page wk-page">
                <div className="header wk-border-line-after">
                    {
                        !isLZWKAPP() && <div className="back" onClick={e => this.onClickBack()}><i className="iconfont icon-jiantou"></i> 返回课程</div>
                    }
                    <div className="title">评论（{commentsCount}）</div>
                    <div className="btn" onClick={e => this.setState({ isShowFilterAs: true })}>筛选</div>
                </div>
                {/* 评论列表 */}
                <div className="comments">
                    {
                        comments && comments.map((item, i) => (
                            <div className="comment-item wk-border-line-after" onClick={e => this.onClickCommentItem(item, i)} key={item.id}>
                                <div className="comment-item-left">
                                    <div className="avatar">
                                        <img src={item.account.small_avatar_url} alt=""/>
                                    </div>
                                </div>
                                <div className="comment-item-right">
                                    <div className="name text-ellipsis">
                                        {this.getLiveroomName(item.account.nickname)}
                                        {item.is_top && <span className="icon"><img src={topCommentImg} alt=""/></span>}
                                        {item.is_filtered && <span className="icon"><img src={niceCommentImg} alt=""/></span>}
                                    </div>
                                    <div className="time">{getHumanTime(item.timestamp)}</div>
                                    <div className="content">{item.content}</div>
                                    {/* 私密回复 */}
                                    {
                                        item.private_replies.length > 0 && (
                                            <div className="reply__list" onClick={e => e.stopPropagation()}>
                                                {
                                                    item.private_replies.map(replyItem => (
                                                        <div key={replyItem.id} className="reply__list-item">
                                                            <span className='reply-tag'>
                                                                <img src={privateCommentImg} alt=""/>
                                                            </span>
                                                            <span className='reply-name'>
                                                                {replyItem.sender.nickname}回复：
                                                            </span>
                                                            <span className='reply-content'>{replyItem.content}</span>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
                {
                    comments && comments.length === 0 && (
                        <div className="no-comment">
                            <img src={noItemImg} alt=""/>
                            <p>暂无评论</p>
                        </div>
                    )
                }
                <Toast icon="success-no-circle" show={this.state.isShowSuccessToast}>{successToastText || '操作成功'}</Toast>

                <Dialog type="ios" title='设为精选' show={this.state.isShowSetNiceDialog} buttons={[{
                    label: '取消',
                    type: 'default',
                    onClick: () => this.setState({ isShowSetNiceDialog: false }),
                }, {
                    label: '确定',
                    onClick: () => this.manageComment('filtered'),
                }]}>
                    将在课程评论区展示，可到评论区进行公开回复，确定设为精选吗？
                </Dialog>
                <Dialog type="ios" title='置顶精选' show={this.state.isShowSetTopDialog} buttons={[{
                    label: '取消',
                    type: 'default',
                    onClick: () => this.setState({ isShowSetTopDialog: false }),
                }, {
                    label: '确定',
                    onClick: () => this.manageComment('top'),
                }]}>
                    将在课程评论区置顶展示，可到评论区进行公开回复，确定置顶精选吗？
                </Dialog>
                <Dialog type="ios" title='删除评论' show={this.state.isShowDelCommentDialog} buttons={[{
                    label: '取消',
                    type: 'default',
                    onClick: () => this.setState({ isShowDelCommentDialog: false }),
                }, {
                    label: '确定',
                    onClick: () => this.handleDelComment(),
                }]}>
                    删除评论后将无法找回，确定删除评论吗？
                </Dialog>
                <Dialog type="ios" title='拉黑' show={this.state.isShowSetBlackDialog} buttons={[{
                    label: '取消',
                    type: 'default',
                    onClick: () => this.setState({ isShowSetBlackDialog: false }),
                }, {
                    label: '确定',
                    onClick: () => this.handleSetBlack(),
                }]}>
                    拉黑的用户可在“直播间操作面板-黑名单”中找回，确定要拉黑吗？
                </Dialog>

                <ActionSheet
                    menus={asMenu}
                    actions={[{
                        label: '取消',
                        onClick: () => this.setState({ isShowAs: false })
                    }]}
                    show={isShowAs}
                    type="ios"
                    onRequestClose={e => this.setState({isShowAs: false})}
                />
                <WKCommentDialog 
                    type="ios" 
                    title='私密回复' 
                    buttons={[{
                        type: 'default',
                        label: '取消',
                        onClick: () => this.setState({ isShowPrivateReplyDialog: false })
                    }, {
                        type: 'primary',
                        label: '发送',
                        onClick: () => {
                            this.handleSendPrivateComment()
                        }
                    }]} 
                    show={this.state.isShowPrivateReplyDialog}
                >
                    <div className="recorded-textarea">
                        <textarea 
                            rows="3" 
                            value={this.state.privateText} 
                            onChange={(e) => this.setState({ privateText: e.target.value })}
                            placeholder='私密回复将通过站内消息发送给学员，回复后不能撤回或删除'
                        >
                        </textarea>
                    </div>
                </WKCommentDialog>
                <WKInfiniteScroll 
                    onTouchBottom={() => this.fetchComments()}
                    isStop={this.state.isScrollPending}
                    isKill={!commentsHasMore} 
                    isShowLoading={true}
                />
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                <div className="filter-as">
                    <ActionSheet
                        menus={[{label: this.renderFilterAs()}]}
                        actions={[{
                            label: '取消',
                            onClick: e => this.setState({ isShowFilterAs: false })
                        }]}
                        show={this.state.isShowFilterAs}
                        type="ios"
                        onRequestClose={e => this.setState({ isShowFilterAs: false })}
                    />
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(LectureCommmentManagePage)


// WEBPACK FOOTER //
// ./src/pages/recordedPage/CommentManagePage.js